/**
 * Read the live geo country (ISO 3166-1 alpha-2) the proxy middleware planted
 * from Cloudflare's CF-IPCountry header. Absent locally (no Cloudflare) — the
 * caller then lets Paddle auto-detect by IP. Reflects the buyer's current
 * location (incl. VPN) so tax + payment methods + the previewed price all match
 * where they actually are.
 *
 * Shared by the pack checkout (prefills the overlay country) and the price
 * preview (localizes the card price) so the card and the overlay key off the
 * SAME country and never disagree.
 */
export function readGeoCountry(): string | undefined {
  if (typeof document === 'undefined') {
    return undefined;
  }
  const match = document.cookie.match(
    /(?:^|;\s*)geo_country=([A-Za-z]{2})(?:;|$)/
  );
  return match?.[1]?.toUpperCase() ?? undefined;
}
